import useTestId from '@ori/testid-generator';
import parser from 'html-react-parser';
import { type FC } from 'react';
import sanitizeHtml from 'sanitize-html';

import { useFooter } from '../../hooks';
import { ContentRoot } from '../ContentRoot';
import { ContentText } from '../ContentText';
import { CONTENT_ALL_PAGES, sanitizeOptions } from './constants';

export const ContentAllPages: FC = () => {
  const { allPagesPagesContent } = useFooter();
  const { getTestId } = useTestId();

  if (!allPagesPagesContent) {
    return null;
  }

  return (
    <ContentRoot testId={getTestId(CONTENT_ALL_PAGES)}>
      <ContentText>{parser(sanitizeHtml(allPagesPagesContent, sanitizeOptions))}</ContentText>
    </ContentRoot>
  );
};
